import { useGetRelease } from 'pages/Distribution/hooks';
import Info from './Info';
import InfoLoader from './InfoLoader';

type PropsType = {
  releaseId: string;
};

const InfoContainer = ({ releaseId }: PropsType) => {
  const { currentRelease } = useGetRelease(releaseId);

  if (!currentRelease) {
    return <InfoLoader />;
  }

  return <Info releaseId={releaseId} />;
};

export default InfoContainer;
